module.exports = __webpack_public_path__ + "static/img/logo.34d7647a.png";